import React from 'react'
import { Leaf, Clock, Award, Heart } from 'lucide-react'

const Features = () => {
  const features = [
    {
      icon: Leaf,
      title: 'Always Fresh',
      description: 'Harvested daily from local farms to ensure maximum freshness and nutrition.'
    },
    {
      icon: Clock,
      title: 'Fast Delivery',
      description: 'Same-day delivery available. Get your fresh produce within hours of ordering.'
    },
    {
      icon: Award,
      title: 'Premium Quality',
      description: 'Every item is carefully inspected to meet our high quality standards.'
    },
    {
      icon: Heart,
      title: 'Healthy Choice',
      description: '100% organic, pesticide-free produce for you and your family.'
    }
  ]

  return (
    <section data-component-path="client/src/components/Features.jsx" data-component-line="30:5" data-component-id="client/src/components/Features.jsx:30:5" className="py-20 bg-gray-50">
      <div data-component-path="client/src/components/Features.jsx" data-component-line="31:7" data-component-id="client/src/components/Features.jsx:31:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Features.jsx" data-component-line="32:9" data-component-id="client/src/components/Features.jsx:32:9" className="text-center mb-16">
          <h2 data-component-path="client/src/components/Features.jsx" data-component-line="33:11" data-component-id="client/src/components/Features.jsx:33:11" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Fresh Harvest?
          </h2>
          <p data-component-path="client/src/components/Features.jsx" data-component-line="36:11" data-component-id="client/src/components/Features.jsx:36:11" className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're committed to bringing you the freshest, healthiest produce with exceptional service
          </p>
        </div>

        <div data-component-path="client/src/components/Features.jsx" data-component-line="41:9" data-component-id="client/src/components/Features.jsx:41:9" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              data-component-path="client/src/components/Features.jsx" 
              data-component-line="45:15" 
              data-component-id={`client/src/components/Features.jsx:45:15-${index}`}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div data-component-path="client/src/components/Features.jsx" data-component-line="50:15" data-component-id={`client/src/components/Features.jsx:50:15-${index}`} className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <feature.icon data-component-path="client/src/components/Features.jsx" data-component-line="51:17" data-component-id={`client/src/components/Features.jsx:51:17-${index}`} className="w-8 h-8 text-green-600" />
              </div>
              <h3 data-component-path="client/src/components/Features.jsx" data-component-line="53:15" data-component-id={`client/src/components/Features.jsx:53:15-${index}`} className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p data-component-path="client/src/components/Features.jsx" data-component-line="54:15" data-component-id={`client/src/components/Features.jsx:54:15-${index}`} className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features